import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useLang } from "@/i18n/LanguageContext";
import { useAuth, startGoogleLogin } from "@/context/AuthContext";
import { AuraMark } from "@/components/site/AuraMark";

const GoogleIcon = () => (
  <svg viewBox="0 0 24 24" className="w-5 h-5"><path fill="#4285F4" d="M22.6 12.2c0-.8-.1-1.5-.2-2.2H12v4.2h5.9a5 5 0 0 1-2.2 3.3v2.7h3.6c2.1-1.9 3.3-4.8 3.3-8z"/><path fill="#34A853" d="M12 23c3 0 5.5-1 7.3-2.7l-3.6-2.7c-1 .7-2.2 1.1-3.7 1.1-2.9 0-5.3-1.9-6.2-4.5H2.1v2.8A11 11 0 0 0 12 23z"/><path fill="#FBBC05" d="M5.8 14.2a6.6 6.6 0 0 1 0-4.3V7.1H2.1a11 11 0 0 0 0 9.9l3.7-2.8z"/><path fill="#EA4335" d="M12 5.4c1.6 0 3.1.6 4.2 1.7l3.2-3.2A11 11 0 0 0 2.1 7.1l3.7 2.8C6.7 7.3 9.1 5.4 12 5.4z"/></svg>
);

export default function Login() {
  const { t } = useLang();
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) navigate("/area-membri", { replace: true });
  }, [user, navigate]);

  return (
    <main className="relative min-h-screen grid place-items-center px-5 pt-24 pb-12 overflow-hidden" data-testid="login-page">
      <img src="/img/aura-agency-square.jpg" alt="" className="absolute inset-0 -z-10 h-full w-full object-cover opacity-25 blur-md scale-110" />
      <div className="absolute inset-0 -z-10 bg-[#050713]/70" />
      <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        className="glass w-full max-w-md rounded-[2rem] p-8 md:p-10">
        <AuraMark className="w-12 h-12" />
        <p className="mt-8 font-mono text-xs uppercase tracking-[0.28em] text-sky-300">{t.login.over}</p>
        <h1 className="mt-3 font-display text-4xl font-extrabold tracking-tight text-white">{t.login.title}</h1>
        <p className="mt-4 text-slate-300 leading-relaxed">{t.login.sub}</p>
        <button onClick={startGoogleLogin} data-testid="google-login-button"
          className="mt-8 w-full flex items-center justify-center gap-3 rounded-full bg-white py-3.5 font-semibold text-[#050713] hover:bg-slate-100 transition-colors">
          <GoogleIcon /> {t.login.google}
        </button>
        <div className="mt-8 flex justify-between text-sm">
          <Link to="/" className="text-slate-400 hover:text-white transition-colors" data-testid="login-back-link">← {t.login.back}</Link>
          <Link to="/admin" className="text-slate-400 hover:text-white transition-colors" data-testid="login-owner-link">{t.login.owner}</Link>
        </div>
      </motion.div>
    </main>
  );
}
